export default __webpack_public_path__ + "static/media/biobankki-logo-transparent.5cbb4804.png";